export default "__VITE_ASSET__H_HmyM$6__"